import Button from 'components/core/button'
import { Upload } from 'lucide-react'
import { FormState, UpdateFormState } from './custom-branding'
import { useCallback, useState } from 'react'
import { FileUploaderResult, ModalFileUploader } from 'lib/components/file-uploader/file-uploader'

export function CustomBrandingLogoSettings({
  formState,
  updateFormState,
}: {
  apiKey: string
  formState: FormState
  updateFormState: UpdateFormState
}) {
  const [showUploaderModal, setShowUploaderModal] = useState(false)

  const onBytescaleUpload = useCallback(
    async (files: FileUploaderResult[]) => {
      updateFormState('s3_logo_filename', files[0].filePath.split('/').pop())
      setShowUploaderModal(false)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-2">
      <div>
        <label className="tw-mb-0">Logo</label>
      </div>
      {!!formState?.logo?.value && (
        <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-4 tw-rounded-md tw-border tw-border-solid tw-border-gray-300 tw-p-4">
          <img src={formState?.logo?.value} alt="White Label Logo" className="tw-h-auto tw-w-36" />
        </div>
      )}
      <Button
        color={'lightGray'}
        onClick={() => setShowUploaderModal(true)}
        className={`tw-flex tw-items-center tw-gap-2 ${
          (formState?.logo?.error && 'tw-ring-2 tw-ring-flushpink-500') || ''
        }`}
      >
        <Upload className="lu-sm" />
        {formState?.logo?.value ? 'Replace' : 'Upload'} Logo
      </Button>
      {formState?.logo?.error && <div className="tw-text-flushpink-500">{formState?.logo?.error}</div>}
      <div>
        <strong>Recommended dimensions:</strong> 1024 x 1024px. Any logo bigger than this will be automatically resized.
        <br />
        <strong>Formats:</strong> JPG or PNG only
        <br />
        <strong>Size:</strong> Max Size 500kb
        <br />
      </div>
      <ModalFileUploader
        isOpen={showUploaderModal}
        setIsOpen={setShowUploaderModal}
        onComplete={onBytescaleUpload}
        localAssets
      />
    </div>
  )
}
